/**
 * projects詳細ページ KVエリア
 */
import AnyStore from '../common/AnyStore';
import ResizeWatch from '../utils/ResizeWatch';
import Vue from 'vue/dist/vue.min.js'

export default class projectsKV {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'projectsKV';

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    // projects詳細のKVを生成
    this.vue = new Vue({
      el: '#vue-projects-mv',
      data: {
        isPC: Useragnt.pc, // KVのアニメはPC版のみ
        isStart: false,
        isComplete: 0,//2で完了
        imgFiles: [],
        styleOpacity: 0,
        styleBgSize: '',
        size: {
          w: 960,
          h: 780,
          imgW: 0,
          imgH: 0,
          gridNumberX: 0,
          gridNumberY: 0,
          gridNumberMax: 0,
          gridSize: 0,
          baseSize: {
            sp: 75,
            pc: 100
          }
        }
      },
      computed: {
        isDevice: () => {
          return function() {
            return AnyStore.setDevice();
          }
        },
        frameStyle: () => {
          return function() {
            if (AnyStore.setDevice() === 'sp') {
              return 'height: auto;';
            } else {
              return 'height:' + this.size.imgH + 'px;';
            }
          }
        },
        wrapStyle: () => {
          return function() {
            return 'height:' + (this.size.gridSize * this.size.gridNumberY) + 'px;' +
                   'width:' + (this.size.gridSize * this.size.gridNumberX) + 'px;';
          }
        },
        wrapStyleSP: () => {
          return function() {
            return 'height:' + this.size.imgH + 'px;' +
              'width:' + this.size.imgW + 'px;';
          }
        },
        gridStyle1: () => {
          return function() {
            const style = 'height: ' +  this.size.gridSize + 'px;' +
              'width: ' +  this.size.gridSize + 'px;';
            return style;
          }
        },
        gridStyle2: () => {
          return function(index, imgSrc) {
            index = index - 1;
            const posAdjust = this.size.gridSize * 1.5;
            const posX = -(this.size.gridSize * (index % this.size.gridNumberX)) + posAdjust;
            const posY = -(this.size.gridSize * Math.floor(index / this.size.gridNumberX)) + posAdjust;
            let transform = '';

            if (!this.isStart) {
              // アニメ再生済み
              const d = AnyStore.hit(2) ? -this.size.gridSize : this.size.gridSize;
              if (AnyStore.hit(2)) {
                transform = `transform: translate(0, ${d}px);`;
              } else {
                transform = `transform: translate(${d}px, 0);`;
              }
            }

            const style = transform +
              'position: absolute;' +
              'left: -' + posAdjust + 'px;' +
              'top: -' + posAdjust + 'px;' +
              'background-image: url(' + imgSrc + ');' +
              this.styleBgSize +
              'background-position: ' + posX + 'px ' + posY + 'px;' +
              'background-repeat: no-repeat;' +
              'height: ' +  (this.size.gridSize*4) + 'px;' +
              'width: ' +  (this.size.gridSize*4) + 'px;' +
              'opacity: ' + this.styleOpacity + ';';
            return style;
          }
        },
        gridStyle3: () => {
          return function(imgSrc) {
            const style = 'background-image: url(' + imgSrc + ');' +
              'background-size: cover;' +
              'background-position: center center;' +
              'background-repeat: no-repeat;' +
              'height: 100%;' +
              'width: 100%;';
            //'opacity: ' + this.styleOpacity + ';';
            return style;
          }
        }
      },
      methods: {
        resize: function() {
          // デバイスによって横幅の仕様が違う
          const isDevice = this.isDevice();

          let imgW = 0;
          if (isDevice === 'sp') {
            imgW = AnyStore.getWindowWidth();
          } else {
            imgW = AnyStore.getWindowWidth() / 2;
          }

          const imgH = this.size.h * (imgW / this.size.w);
          const gridNumberX = Math.floor(imgW / this.size.baseSize[isDevice]);
          const gridSize = Math.ceil(imgW / gridNumberX);
          const gridNumberY = Math.ceil(imgH / gridSize);
          this.size.imgW = imgW;
          this.size.imgH = imgH;
          this.size.gridSize = gridSize;
          this.size.gridNumberX = gridNumberX;
          this.size.gridNumberY = gridNumberY;
          this.size.gridNumberMax = gridNumberX * gridNumberY;

          this.styleOpacity = (this.isComplete === 2) ? 1 : 0;
          this.styleBgSize = 'background-size: ' + (imgW*1.01) + 'px ' + (imgH*1.01) + 'px;';
        },
        start() {
          if (this.isPC) {
            this.startPC();
          } else {
            this.startSP();
          }
        },
        startCompPC() {
          this.isComplete++;
          if (this.isComplete == 2) {
            this.isStart = true;
          }
        },
        startCompSP() {
          this.isStart = true;
        },
        startPC() {
          // PCはグリッド
          this.$el.querySelectorAll('.l-projects-mv__col2').forEach((col, i1) => {
            const grids = AnyStore.arrShuffle(Array.from(col.querySelectorAll('div > .picture-div')));
            TweenMax.staggerTo(grids, 1.0, {
                x: 0,
                y: 0,
                opacity: 1,
                ease: Quint.easeInOut,
                stagger: {
                  amount: 0.8,
                  ease: Quint.easeOut,
                }
              },
              0,
              this.startCompPC.bind(this)
            );
          });
        },
        startSP() {
          // SPは通常の1枚画像
          TweenMax.staggerFromTo(this.$el.querySelectorAll('.l-projects-mv__col2 > .col-wrap'), 0.4, {
              opacity: 0,
            },{
              opacity: 1,
              ease: Quint.easeInOut,
            },
            0.05
          );
          TweenMax.staggerFromTo(this.$el.querySelectorAll('.l-projects-mv__col2 > .col-wrap'), 1.0, {
              opacity: 0,
              scale: 1.3
            },{
              scale: 1,
              opacity: 1,
              ease: Quint.easeOut,
            },
            0.05,
            this.startCompSP.bind(this)
          );
        }
      },
      created() {
        this.imgFiles = JSON.parse(document.getElementById('js-param-projects').textContent);
      },
      mounted() {
        this.resize();
      }
    });

    //this.resizeUpdate();
    ResizeWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {
    this.vue.start();
  }

  /**
   * ウィンドウリサイズ
   */
  resizeUpdate() {
    this.vue.resize();
  }
}
